export const getProfileData = (instance) => {
  return instance()
    .get(`/onboarding/api/v1/profile/`)
    .then((response) => {
      return response?.data;
    });
};

export const getFundsData = (instance) => {
  return instance()
    .get(`/fund/api/v1/info/funds/`)
    .then((response) => {
      return response?.data;
    });
};

export const getFundsDetailData = (instance, dscode) => {
  return instance()
    .get(`/fund/api/v1/fund/${dscode}/`)
    .then((response) => {
      return response?.data;
    });
};

export const getUserFundData = (instance, dscode) => {
  return instance()
    .get(`/fund/api/v1/user_fund/${dscode}/`)
    .then((response) => {
      return response?.data;
    });
};

export const getFundChartsData = (instance, id, params) => {
  return instance()
    .get(`/fund/api/v2/info/chart/${id}/`, { params })
    .then((response) => {
      return response?.data;
    });
};

export const getAssetsData = (instance) => {
  return instance()
    .get(`/fund/api/v1/user_asset/`)
    .then((response) => {
      return response?.data;
    });
};

export const getPortfolios = (instance) => {
  return instance()
    .get(`/pma/api/v1/portfolio/all/`)
    .then((response) => {
      return response?.data;
    });
};

export const onCounselingCall = (instance, data) => {
  return instance()
    .post(`/onboarding/api/v1/user-counselling/`, data)
    .then((response) => {
      return response?.data;
    });
};

export const getFundBanksData = (instance, dsCode) => {
  return instance()
    .get(`/fund/api/v1/bank_accounts/${dsCode}/`)
    .then((response) => {
      return response?.data;
    });
};

export const getPmaBanksData = (instance) => {
  return instance()
    .get(`/pma/api/v1/bank_accounts/`)
    .then((response) => {
      return response?.data;
    });
};

export const submitReferral = (instance, code) => {
  return instance()
    .get(`/onboarding/api/v1/referral/activate/${code}/`)
    .then((response) => {
      return response;
    });
};

export const getPwaConfig = (instance) => {
  return instance()
    .get(`/general/api/v1/settings/pwa/`)
    .then((response) => {
      return response?.data;
    });
};

export const getTransactionReceipt = (instance, transactionUuid) => {
  return instance()
    .get(`/bank/api/v1/transaction/receipt/${transactionUuid}/`)
    .then((response) => response?.data);
};

export const getBalanceAccount = (instance, account_uuid) => {
  return instance({ showErrorsAlways: true })
    .get(`/bank/api/v1/account/balance/${account_uuid}/`)
    .then((response) => {
      return response?.data;
    });
};

export const getVideoById = (instance, id) => {
  return instance()
    .get(`/general/api/v1/video/${id}/`)
    .then((response) => {
      return response?.data;
    });
};

export const getFundConfig = (instance, id) => {
  return instance()
    .get(`/general/api/v1/settings/fund-${id}/`)
    .then((response) => {
      return response?.data;
    });
};

export const getAllPortfos = (instance) => {
  return instance()
    .get(`/pma/api/v1/portfolio/plans/`)
    .then((response) => {
      return response?.data;
    });
};

export const postStartSurvey = (instance, surveyId, data) => {
  return instance()
    .post(`/recommendation/api/v1/start-survey/${surveyId}/`, data)
    .then((response) => {
      return response?.data;
    });
};

export const postSubmitAnswer = (instance, data) => {
  return instance({ showErrorsAlways: true })
    .post(`/recommendation/api/v1/submit-answer/`, data)
    .then((response) => {
      return response?.data;
    });
};

export const postLastCompleteSurvey = (instance, surveyId, data) => {
  return instance()
    .post(`/recommendation/api/v1/last-complete-survey/${surveyId}/`, data)
    .then((response) => {
      return { data: response?.data, error: response?.response?.data };
    });
};

export const postUserSurveyDetail = (instance, data) => {
  return instance()
    .post(`/recommendation/api/v1/user-survey-Detail/`, data)
    .then((response) => {
      return response?.data;
    });
};

export const postPreviousQuestion = (instance, userSurveyId, data) => {
  return instance()
    .post(`/recommendation/api/v1/previous-question/${userSurveyId}/`, data)
    .then((response) => {
      return response?.data;
    });
};

export const createUserAddress = (instance, data) => {
  return instance()
    .post(`/onboarding/api/v1/user-addresses/`, data)
    .then((response) => {
      return { data: response?.data, error: response?.response?.data };
    });
};

export const getUserAddress = (instance) => {
  return instance()
    .get(`/onboarding/api/v1/user-addresses/`)
    .then((response) => {
      return response?.data;
    });
};

export const getProvincesData = (instance) => {
  return instance()
    .get(`/general/api/v1/province/`)
    .then((response) => {
      return response?.data;
    });
};

export const getCitiesData = (instance, id) => {
  return instance()
    .get(`/general/api/v1/province/${id}/city/`)
    .then((response) => {
      return response?.data;
    });
};

export const postUploadVideo = (instance, data) => {
  return instance()
    .post(`/onboarding/api/v1/onb/upload/video/`, data)
    .then((response) => {
      return response?.data;
    });
};

export const postInquiryAmount = (instance, data) => {
  return instance({ showErrorsAlways: true })
    .post(`/onboarding/api/v1/onb/inquiry/amount/`, data)
    .then((response) => {
      return { data: response?.data, error: response?.response?.data };
    });
};

export const postVoucherRedeem = (instance, data) => {
  return instance({ showErrorsAlways: true })
    .post(`/prize/api/v1/voucher/redeem/`, data)
    .then((response) => {
      return { data: response?.data, error: response?.response?.data };
    });
};
